import { render } from "./Subgrupos.vue?vue&type=template&id=1254b4e8"
import script from "./Subgrupos.vue?vue&type=script&lang=js"
export * from "./Subgrupos.vue?vue&type=script&lang=js"

import "./Subgrupos.vue?vue&type=style&index=0&id=1254b4e8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__